export default __webpack_public_path__ + "static/media/DragIcon.5f48d8fb.svg";